module.exports = __webpack_public_path__ + "img/logo_couleur.8eae533e.png";